var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14211",
    "data-name": "Group 14211",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2867",
    "data-name": "Rectangle 2867",
    width: 20,
    height: 20,
    fill: "#001e2a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13294",
    "data-name": "Group 13294",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12970",
    "data-name": "Path 12970",
    d: "M7.3,9.883a1.262,1.262,0,0,0,0-2.524h0a1.262,1.262,0,0,0,0,2.524",
    fill: "#001e2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12971",
    "data-name": "Path 12971",
    d: "M12.677,9.882a1.262,1.262,0,1,0-1.26-1.262,1.264,1.264,0,0,0,1.26,1.262",
    fill: "#001e2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12972",
    "data-name": "Path 12972",
    d: "M12.082,10.716a.778.778,0,0,0-.738.578,1.107,1.107,0,0,1-.075.275.562.562,0,0,1-.274.219,2.4,2.4,0,0,1-1.965.021.627.627,0,0,1-.306-.235,1.339,1.339,0,0,1-.093-.308A.761.761,0,0,0,7.192,11.2a1.055,1.055,0,0,0-.022.627A1.975,1.975,0,0,0,7.9,12.912a3.074,3.074,0,0,0,1.212.537,3.821,3.821,0,0,0,2.457-.239,2.136,2.136,0,0,0,1.257-1.445,1.082,1.082,0,0,0-.029-.548.764.764,0,0,0-.716-.5",
    fill: "#001e2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12973",
    "data-name": "Path 12973",
    d: "M17.81,4.342H10.763V3.415a1.829,1.829,0,0,0,1-1.636,1.774,1.774,0,1,0-3.548,0A1.827,1.827,0,0,0,9.221,3.415v.927H2.192A2.238,2.238,0,0,0,0,6.608v7.428A2.337,2.337,0,0,0,.633,15.63a2.222,2.222,0,0,0,1.561.679H4.2v2.92a.764.764,0,0,0,.456.7A.727.727,0,0,0,4.963,20h0a.762.762,0,0,0,.517-.2l3.824-3.49h8.5A2.24,2.24,0,0,0,20,14.036V6.609a2.236,2.236,0,0,0-2.19-2.267M10,1.277a.5.5,0,1,1-.5.5.5.5,0,0,1,.5-.5m7.806,13.491H9.013a.754.754,0,0,0-.515.2L5.736,17.486V15.538a.771.771,0,0,0-.769-.77H2.2a.641.641,0,0,1-.447-.195.776.776,0,0,1-.214-.537V6.6a.7.7,0,0,1,.658-.719H17.8a.7.7,0,0,1,.662.725v7.434a.7.7,0,0,1-.657.726",
    fill: "#001e2a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.db4dc928c85107c60ee3a2eceadbbd9f.svg";
export { ForwardRef as ReactComponent };